module.exports = __webpack_public_path__ + "img/chest-ectomorph-female.5e994d1a.svg";